<template>
  <Select
    v-model="value"
    @on-change="handleChanged"
    placeholder="Enter email to search"
    :disabled="loading"
    clearable
    filterable>
    <Option v-for="m in usersMap" :value="m.value" :key="`user-${m.value}`">{{ m.label }}</Option>
  </Select>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'UserSearchAutoComplete',
  props: {
    userId: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      value: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters(['users']),
    usersMap: function () {
      return _.map(this.users, function (u) {
        return { value: u.id, label: `${u.name} (${u.email})` }
      })
    }
  },
  created() {
    this.value = this.userId
    this.loading = true
    this.getUsers().finally(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions(['getUsers']),
    handleChanged (uid) {
      this.$emit('update:userId', uid)
    }
  },
  watch: {
    userId: function (uid) {
      this.value = uid
    }
  }
}
</script>
